import "normalize.css";
import "./theme/index.scss";
// import './third/json2';
// import './third/jPages';
import * as React from "react";
import * as ReactDOM from "react-dom";
// import { configRoute } from "./route";
import App from "./App";
import * as subpub from "./utils/subpub";
import Global from './utils/global';

window.Global=Global;

async function start() {
  // await userInfoToAppState();
  return Global.init();
}

export function render() {
  ReactDOM.render(
    <App />,
    document.getElementById("appzhhy"),
    () => {
      // Spinner.show({}, $('#app4366V3_1'));
      // loadSuccessNotify();
    }
  );
}

window.onload = () => {
  start()
    .then(() => {
      // configRoute();
      render();
    })
    .catch((err = {}) => {
      if (err.errmsg || err.message) {
        // dialogTips(err.errmsg || err.message);
        console.error(err)
      }
      // alert(JSON.stringify(err));
    });
};



// WEBPACK FOOTER //
// ./src/index.tsx